// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { rfqQuoteDetailsPageContainerStyles } from "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsPageContainer";
import { css } from "styled-components";

rfqQuoteDetailsPageContainerStyles.mainContainer = {
    ...rfqQuoteDetailsPageContainerStyles.mainContainer,
    css: css`
        ${rfqQuoteDetailsPageContainerStyles.mainContainer?.css}
        div[class^="GridOffset"] {
            width: auto;
        }
    `,
};

rfqQuoteDetailsPageContainerStyles.leftColumnGridItem = {
    ...rfqQuoteDetailsPageContainerStyles.leftColumnGridItem,
    width: 12,
};

rfqQuoteDetailsPageContainerStyles.leftColumnTopGridItem = {
    ...rfqQuoteDetailsPageContainerStyles.leftColumnTopGridItem,
    width: [12, 12, 6, 7, 8],
};

rfqQuoteDetailsPageContainerStyles.leftColumnBottomGridItem = {
    ...rfqQuoteDetailsPageContainerStyles.leftColumnBottomGridItem,
    width: [12, 12, 6, 5, 4],
    css: css`
        ${rfqQuoteDetailsPageContainerStyles.leftColumnBottomGridItem?.css}
        padding: 0;
        &&& {
            margin-bottom: 20px;
        }
    `,
};

rfqQuoteDetailsPageContainerStyles.rigthColumnGridItem = {
    ...rfqQuoteDetailsPageContainerStyles.rigthColumnGridItem,
    width: 12,
};
